export const ulbData = {
  "Nagar Nigam": ["Lucknow", "Jhansi", "Ghaziabad", "Bareilly", "Ayodhya", "Varanasi", "Kanpur"],
  "Nagar Palika": ["Barabanki", "Raebareli"],
  "Nagar Panchayat": [],
};

export const mockData = {
  "2025-26 (Running)": {
    "All ULBs": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [4200, 4800, 5100, 5600],
        expenditure: [3100, 3600, 3900, 4200],
      },
    },
    "Nagar Nigam": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [2500, 2900, 3100, 3400],
        expenditure: [1800, 2100, 2400, 2700],
      },
      Lucknow: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [620, 710, 680, 750, 800],
        expenditure: [450, 520, 490, 560, 600],
      },
      Jhansi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [310, 340, 320, 360, 390],
        expenditure: [400, 250, 240, 270, 290],
      },
      Ghaziabad: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [540, 590, 560, 610, 650],
        expenditure: [390, 430, 410, 450, 480],
      },
      Bareilly: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [280, 310, 295, 330, 355],
        expenditure: [200, 225, 215, 245, 265],
      },
      Ayodhya: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [195, 215, 205, 230, 248],
        expenditure: [140, 158, 150, 170, 183],
      },
      Varanasi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [490, 535, 510, 558, 595],
        expenditure: [355, 390, 372, 408, 435],
      },
      Kanpur: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [580, 630, 600, 658, 700],
        expenditure: [420, 460, 438, 480, 512],
      },
    },
    "Nagar Palika": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [980, 1120, 1200, 1340],
        expenditure: [720, 840, 910, 1020],
      },
      Barabanki: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [145, 158, 150, 165, 178],
        expenditure: [105, 115, 110, 121, 131],
      },
      Raebareli: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [132, 144, 137, 151, 162],
        expenditure: [96, 105, 100, 110, 119],
      },
    },
    "Nagar Panchayat": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [420, 480, 510, 560],
        expenditure: [310, 360, 385, 425],
      },
    },
  },
  "2024-25": {
    "All ULBs": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [3800, 4200, 4500, 4900],
        expenditure: [2800, 3100, 3400, 3700],
      },
    },
    "Nagar Nigam": {
      "All ULBs": {
         labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [2200, 2500, 2750, 3000],
        expenditure: [1600, 1850, 2050, 2250],
      },
      Lucknow: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [580, 650, 710, 780],
        expenditure: [420, 475, 520, 575],
      },
      Jhansi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [280, 315, 345, 378],
        expenditure: [205, 232, 254, 278],
      },
      Ghaziabad: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [500, 560, 615, 672],
        expenditure: [365, 410, 450, 492],
      },
      Bareilly: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [260, 292, 320, 350],
        expenditure: [190, 214, 235, 257],
      },
      Ayodhya: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [182, 204, 224, 245],
        expenditure: [133, 150, 164, 180],
      },
      Varanasi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [455, 510, 560, 613],
        expenditure: [333, 374, 410, 449],
      },
      Kanpur: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [540, 605, 664, 727],
        expenditure: [395, 443, 486, 532],
      },
    },
    "Nagar Palika": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [890, 1000, 1095, 1198],
        expenditure: [655, 735, 805, 881],
      },
      Barabanki: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [132, 148, 162, 177],
        expenditure: [97, 109, 119, 130],
      },
      Raebareli: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [120, 135, 148, 162],
        expenditure: [88, 99, 108, 119],
      },
    },
    "Nagar Panchayat": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [380, 428, 469, 513],
        expenditure: [280, 315, 345, 378],
      },
    },
  },
  "2023-24": {
    "All ULBs": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [3300, 3650, 3950, 4250],
        expenditure: [2450, 2710, 2930, 3150],
      },
    },
    "Nagar Nigam": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [1950, 2160, 2340, 2520],
        expenditure: [1450, 1605, 1738, 1872],
      },
      Lucknow: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [510, 565, 612, 660],
        expenditure: [375, 416, 451, 485],
      },
      Jhansi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [248, 275, 298, 321],
        expenditure: [182, 202, 219, 236],
      },
      Ghaziabad: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [445, 493, 534, 575],
        expenditure: [326, 362, 392, 422],
      },
      Bareilly: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [231, 256, 277, 298],
        expenditure: [170, 188, 204, 219],
      },
      Ayodhya: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [162, 179, 194, 209],
        expenditure: [119, 132, 143, 154],
      },
      Varanasi: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [405, 449, 486, 523],
        expenditure: [297, 329, 357, 384],
      },
      Kanpur: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [480, 532, 576, 620],
        expenditure: [352, 390, 423, 455],
      },
    },
    "Nagar Palika": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [790, 875, 948, 1021],
        expenditure: [580, 642, 696, 749],
      },
      Barabanki: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [117, 130, 141, 152],
        expenditure: [86, 95, 103, 111],
      },
      Raebareli: {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [107, 118, 128, 138],
        expenditure: [78, 87, 94, 101],
      },
    },
    "Nagar Panchayat": {
      "All ULBs": {
        labels: ["1994-95", "1995-96", "1996-97", "1997-98"],
        receipts: [338, 374, 405, 436],
        expenditure: [248, 275, 298, 321],
      },
    },
  },
};

export const getChartData = (filters) => {
  const { financialYear, ulbType, ulbName } = filters;
  const yearData = mockData[financialYear] || mockData["2025-26 (Running)"];
  const typeData = yearData[ulbType] || yearData["All ULBs"];
  const nameData = typeData[ulbName] || typeData["All ULBs"];
  return nameData;
};

export const defaultFilters = {
  financialYear: "2025-26 (Running)",
  ulbType: "All ULBs",
  ulbName: "All ULBs",
};



// WEBPACK FOOTER //
// src/modules/employee/Inbox/components/mockData.js